<prlw-user-list-tab-ui
  [items]="items$ | async"
  [params]="params$ | async"
  (eventChangeParams)="handleChangeParams($event)"
></prlw-user-list-tab-ui>
